import * as React from 'react';
import { HeaderActionsItem } from './item';
const HeaderActions = (props) => {
    const { checkIfDropdownShouldBeVisible, currentAnimatingSection, dropdownContainer, dropdownOffsetY, items, location = 'bottom', nav, onActionClick, onDropdownClose, onDropdownTransitionExited, sso, } = props;
    const BEM = () => {
        const classArray = ['header__actions'];
        if (sso && sso.isLoggedIn) {
            classArray.push('is-logged-in');
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM() },
        React.createElement("ul", { className: "header__actions-list" }, items.map(item => {
            const handleActionClick = (event) => {
                event.persist();
                event.preventDefault();
                onActionClick(item.id);
                if (item.onClick) {
                    item.onClick(event);
                }
            };
            const dropdownContent = item.dropdownContent || (item.id === 'nav' ? nav.dropdownContent : undefined);
            const dropdownPadding = item.dropdownPadding || (item.id === 'nav' ? nav.dropdownPadding : undefined);
            return (React.createElement(HeaderActionsItem, Object.assign({}, item, { 
                // override location to normalize "all"
                location: location, dropdownContent: dropdownContent, dropdownContentRef: item.id === 'nav' ? nav.dropdownRef : undefined, dropdownContainer: dropdownContainer, dropdownPadding: dropdownPadding, dropdownOffsetY: dropdownOffsetY, isCurrent: checkIfDropdownShouldBeVisible === null || checkIfDropdownShouldBeVisible === void 0 ? void 0 : checkIfDropdownShouldBeVisible(item.id), isCurrentAnimating: currentAnimatingSection === item.id, onDropdownClose: onDropdownClose, onDropdownTransitionExited: () => onDropdownTransitionExited === null || onDropdownTransitionExited === void 0 ? void 0 : onDropdownTransitionExited(item.id), onClick: dropdownContent || item.id === 'search' ? handleActionClick : item.onClick, onToggle: () => onActionClick(item.id), isPlaceholder: item.id === 'sso' && sso && !sso.isSsoLoaded, key: item.id, asModal: true })));
        }))));
};
export { HeaderActions as default };
